import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import * as moment from 'moment';
import { Moment } from 'moment';
import { CalendarEvent } from 'angular-calendar';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatColors } from '../../../../../core/matColors';
import { Schedule } from '../product.model';

@Component({
    selector     : 'fuse-closed-dates-form-dialog',
    templateUrl  : './closed-dates-form.component.html',
    styleUrls    : ['./closed-dates-form.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ClosedDatesFormDialogComponent implements OnInit
{
    schedule: Schedule;
    dialogTitle: string;
    eventForm: FormGroup;
    action: string;
    presetColors = MatColors.presets;

    constructor(
        public dialogRef: MatDialogRef<ClosedDatesFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private formBuilder: FormBuilder,
        public snackBar: MatSnackBar,
    )
    {
        this.schedule = data.schedule;
        this.action = data.action;

        if ( this.action === 'edit' )
        {
            this.dialogTitle = ['Créneau', this.schedule.embarcadere, '-', this.schedule.time.replace(':', 'h')].join(' ');
        }

        this.eventForm = this.createEventForm();
    }

    ngOnInit() {}

    createEventForm()
    {
        return new FormGroup({
            day: new FormControl('', [Validators.required]),
        });
    }

    toUTCSmallDate(date?: any) {
        if (!date || typeof date === 'undefined') {
            date = new Date();
        }
        if (date instanceof moment) {
            date = (date as Moment).toDate();
        }
        if (typeof date === 'string') {
            date = new Date(date);
        }
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0));
    }

    addClosedDate() {
        const newDate = this.toUTCSmallDate(this.eventForm.get('day').value);
        if ( !newDate )
        {
            return;
        }
        const foundTime = this.schedule.closedDates.find((day) => this.toUTCSmallDate(day) === newDate);
        if (foundTime) {
            this.snackBar.open('Cette date a déjà été ajoutée', 'OK', {
                verticalPosition: 'top',
                duration        : 2000
            });
            return;
        }
        if (!this.schedule.closedDates) {
            this.schedule.closedDates = [];
        }
        this.schedule.closedDates.push(newDate);
        this.schedule.closedDates.sort((a, b) => a.getTime() - b.getTime());
    }

    removeClosedDate(date) {
        const index = this.schedule.closedDates.indexOf(date);
        if ( index >= 0 )
        {
            this.schedule.closedDates.splice(index, 1);
        }
    }

    clearClosedDates() {
        if (!this.schedule.closedDates || !this.schedule.closedDates.length) {
            return;
        }
        this.schedule.closedDates = [];
    }

}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/product/closed-dates/closed-dates-form.component.ts